import { render, staticRenderFns } from "./ConteosArchivadosTable.vue?vue&type=template&id=7554b071"
import script from "./ConteosArchivadosTable.vue?vue&type=script&lang=js"
export * from "./ConteosArchivadosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports